import React from 'react'
import './Footer.css';
import logo from '../../assets/Home/border.png'
const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-parent">
            <img src = {logo} alt="Border-curver"/>
      </div>
    </div>
  )
}

export default Footer
